/**
 * @typedef Vec3
 * @prop {number} x
 * @prop {number} y
 * @prop {number} z
 * 
 * @typedef BoundingBox
 * @prop {Vec3} min
 * @prop {Vec3} max
 * 
 * @param {Array<{vertices:Array<number>}>} entities 
 * @returns {BoundingBox}
 */
export function boundingBox(entities=[]){
  try{
  let minx,miny,minz,maxx,maxy,maxz
  entities.forEach(({vertices, transforms})=>{
    if(!vertices) return
    let x, y, z, vt
    // C2 fix: Changed i=5 to i=2 to process ALL vertices including vertex 0
    // The old code only processed vertex 0 of the first entity (via initialization)
    // but skipped vertex 0 of subsequent entities
    for(let i=2; i<vertices.length; i+=3){
      if(transforms){
        vt = transform([], [vertices[i-2], vertices[i-1],vertices[i]], transforms)
        x = vt[0]
        y = vt[1]
        z = vt[2]
      }else{
        x = vertices[i-2]
        y = vertices[i-1]
        z = vertices[i]
      }
      if(minx === undefined){
        minx = maxx = x
        miny = maxy = y
        minz = maxz = z
      }else{
        minx = Math.min(minx,x)
        miny = Math.min(miny,y)
        minz = Math.min(minz,z)
        maxx = Math.max(maxx,x)
        maxy = Math.max(maxy,y)
        maxz = Math.max(maxz,z)
      }
    }
  })
  // Return origin-centered unit box if no vertices were found
  if (minx === undefined) {
    return {min:{x:0,y:0,z:0}, max:{x:0,y:0,z:0}}
  }
  return {min:{x:minx,y:miny,z:minz}, max:{x:maxx,y:maxy,z:maxz}}
  }catch(e){
    e.message = `boundingBox calculation failed: ${e.message}`
    throw e
  }
}


const transform = (out, vector, matrix) => {
  const x = vector[0]
  const y = vector[1]
  const z = vector[2]
  let w = matrix[3] * x + matrix[7] * y + matrix[11] * z + matrix[15]
  w = w || 1.0
  out[0] = (matrix[0] * x + matrix[4] * y + matrix[8] * z + matrix[12]) / w
  out[1] = (matrix[1] * x + matrix[5] * y + matrix[9] * z + matrix[13]) / w
  out[2] = (matrix[2] * x + matrix[6] * y + matrix[10] * z + matrix[14]) / w
  return out
}
